export default __webpack_public_path__ + "static/media/02.89b3f6e3.svg";